// @flow
import React from 'react';
import styled from 'styled-components';
import { colors, getIcon } from 'bench-style-constants';

const StyledIcon = styled.svg`
  fill: ${({ color }) => color || colors.charcoal};
  height: ${({ size }) => size || '16px'};
  width: ${({ size }) => size || '16px'};
  min-width: ${({ size }) => size || '16px'};
  min-height: ${({ size }) => size || '16px'};
`;

type IconProps = {
  color: ?string,
  icon: string,
  size: ?string,
};

const Icon = ({ icon: iconName, color, size }: IconProps) => {
  const icon = getIcon(iconName);

  const accessibilityAttributes = icon.title && {
    ariaDescribedBy: iconName,
    role: 'img',
  };

  return (
    <StyledIcon
      {...accessibilityAttributes}
      color={color}
      size={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      {icon.title && <title id={iconName}>{icon.title}</title>}
      <path d={icon.path} />
    </StyledIcon>
  );
};

export default Icon;
